import { Main } from './components/containers';

/**
 * Página de detalle de orden de trabajo extra
 */
const ExtraWorkOrderDetail = () => {
  return <Main />;
};

export default ExtraWorkOrderDetail;
